import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VBtn,{staticClass:"my-3 mr-3",on:{"click":_vm.newOrder}},[_vm._v("Nueva Orden")]),_c('print-ticket',{ref:"printer",attrs:{"disabled":!_vm.order,"order":_vm.order,"small":false,"icon":false}}),_c(VDivider),_c('show-order',{attrs:{"identifier":_vm.identifier}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }